import { lazy } from 'react'

export const AgeRange = lazy(() => import('./v1/AgeRange'))
export const AgeRangeV2 = lazy(() => import('./v2/AgeRangeV2'))
export const AgeRangeV3 = lazy(() => import('./v3/AgeRangeV3'))
export const AgeRangeV4 = lazy(() => import('./v4/AgeRangeV4'))
export const KitAgeRangeV1 = lazy(() => import('./kitV1/KitAgeRangeV1'))
export const KitAgeRangeV2 = lazy(() => import('./kitV2/KitAgeRangeV2'))
